/* globals Fancybox */
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

Fancybox.bind('.popup-youtube, .popup-vimeo', {
	on: {
		done: (fancybox) => {
			fancybox.container.querySelector('.is-close-btn').focus();
			const iframe = fancybox.container.querySelector('iframe');
			iframe.setAttribute('title', 'Play Video');
			// Add &dnt=1 to Vimeo URLs
			if (iframe.src.includes('vimeo.com') && !iframe.src.includes('dnt=1')) {
				iframe.src += (iframe.src.includes('?') ? '&' : '?') + 'dnt=1';
			}
		},
	},
});

const strl_responsive_iframes = function () {
  const iframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]');

  iframes.forEach(iframe => {
    // Add &dnt=1 to Vimeo URLs
    if (iframe.src.includes('vimeo.com') && !iframe.src.includes('dnt=1')) {
      iframe.src += (iframe.src.includes('?') ? '&' : '?') + 'dnt=1';
    }
    const videoContainer = document.createElement('div');
    videoContainer.classList.add('video-container', 'active');
    iframe.parentNode.insertBefore(videoContainer, iframe);
    videoContainer.appendChild(iframe);
  });
};

strl_responsive_iframes();
